import React from 'react';
import { Label } from 'semantic-ui-react';

import { Bell } from 'src/components/icons';
import { useAppDispatch, useAppSelector } from 'src/store';
import drawer from 'src/store/ui/drawer';
import { drawer_name } from 'src/components/coreUI/NotificationHistoryDrawer';

const NotificationHistory: React.FC = () => {
  const dispatch = useAppDispatch();
  const count = useAppSelector(
    (state) => state.model.user_notification.unread_count,
  );

  return (
    <div
      className="relative mt-8"
      onClick={() => dispatch(drawer.open({ name: drawer_name }))}
    >
      <Bell />
      {!!count && (
        <Label size="tiny" circular color="red" floating>
          {count}
        </Label>
      )}
    </div>
  );
};

export default NotificationHistory;
